import styled from '@emotion/styled'

export const V2L1FormPageBreak = styled.div({
	// 20251212 DAN'S PRINT HACKS FOR APPEASING CUSTOMERS
	// we've found at this point that eliminating all page breaks is a
	// better approach to giving the customer what they actually want.
	// breakAfter: 'page',
})
